<script setup lang="ts">
import { useStatsigEventsStore } from '@apps/main/new-desktop/core/stores';

import { AppButton, AppSlideUpAndDownTransition } from '@libs/ui';

import { useGlobalCurrencyStore } from '../../../../core/stores/globalCurrencyStore';
import { useTripOverviewPanelsStore, useTripSummaryStore } from '../../stores';

const tripSummaryStore = useTripSummaryStore();
const globalCurrencyStore = useGlobalCurrencyStore();
const tripOverviewPanelsStore = useTripOverviewPanelsStore();
const statsigEventsStore = useStatsigEventsStore();

function onTotalPriceClicked(): void {
  statsigEventsStore.logTripOverviewTripSummaryPanelOpened();
  tripOverviewPanelsStore.openTripSummaryPanel();
}
</script>

<template>
  <AppSlideUpAndDownTransition>
    <div class="trip-price-summary-footer-mobile">
      <div class="left-side">
        <div class="cart">
          <AppButton
            type="secondary"
            state="enabled"
            size="medium"
            :icon="{ name: 'cart' }"
            @click="onTotalPriceClicked"
          />
          <div class="cart-count">
            {{ tripSummaryStore.tripPriceSegments.length }}
          </div>
        </div>
        <div class="total-price">
          <div class="text">{{ $t('planner.total_price') }}</div>
          <div class="amount">
            {{
              globalCurrencyStore.formatMoney(
                tripSummaryStore.tripTotalPrice +
                  tripSummaryStore.tripTotalAddonsPrice
              )
            }}
          </div>
        </div>
      </div>

      <div class="trip-summary-actions">
        <AppButton
          type="important"
          size="large"
          :state="tripSummaryStore.bookingButtonState"
          @click="tripSummaryStore.onBookClicked"
        >
          {{ $t('planner.book_trip') }}
        </AppButton>
      </div>
    </div>
  </AppSlideUpAndDownTransition>
</template>

<style scoped lang="scss">
.trip-price-summary-footer-mobile {
  width: 100vw;

  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 var(--spacing-16);
  border-top: 1px solid var(--color-neutral-30);

  .left-side {
    display: flex;
    gap: var(--spacing-12);

    .cart {
      position: relative;

      .cart-count {
        position: absolute;
        top: -10px;
        right: -10px;

        display: flex;
        align-items: center;
        justify-content: center;

        border-radius: 50%;
        background-color: var(--color-neutral-70);
        color: var(--color-white);
        @include font-label-s-bold;
        padding: 4px;
        min-width: 23px;
        min-height: 23px;
      }
    }

    .total-price {
      color: var(--color-neutral-70);

      display: flex;
      flex-direction: column;
      gap: var(--spacing-8);

      .text {
        @include font-label-s-light;
        color: var(--color-neutral-70);
      }
    }

    .amount {
      @include font-label-xl-bold;
    }
  }
}
</style>
